import React, { useContext, useMemo } from "react";
import MessageFavoriteFieldsContext from "views/components/contexts/MessageFavoriteFieldsContext";
import { AdditionalContext } from "views/logic/ActionContext";
const MessageDetailAdditionalContextProvider = ({
  isLocalNode,
  children = null
}) => {
  const { toggleField, favoriteFields } = useContext(MessageFavoriteFieldsContext);
  const additionalContext = useMemo(
    () => ({
      isLocalNode,
      toggleFavoriteField: toggleField,
      favoriteFields
    }),
    [favoriteFields, isLocalNode, toggleField]
  );
  return /* @__PURE__ */ React.createElement(AdditionalContext.Provider, { value: additionalContext }, children);
};
export default MessageDetailAdditionalContextProvider;
